run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'workplan']

export default function run ($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, workplan) {
  $templateCache.put('indicators.html', require('./indicators.html'))
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/indicators/indicators.run.js